import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'red';
    isProgress?: boolean;
    children: React.ReactNode;
}

const WcnButton: React.FC<ButtonProps> = ({
    variant = 'primary',
    isProgress = false,
    disabled = false,
    type = 'button',
    children,
    className = '',
    ...rest
}) => {
    const classes = ['btn', `btn--${variant}`, isProgress ? 'is-progress' : '', className].filter(Boolean).join(' ');

    return (
        <button type={type} className={classes} disabled={disabled} {...rest}>
            {children}
        </button>
    );
};

export default WcnButton;
